/* eslint-disable no-unused-vars */
import { BreadcrumbLoggerInterface } from 'shared/lib/sentry/breadcrumb.logger.interface';


export abstract class BrowserStorageAbstract {
    storageType: string = '';

    protected constructor (
        private readonly _storage: Storage,
        private readonly _breadcrumbLogger: BreadcrumbLoggerInterface
    ) {}

    getItemRaw (key: string): string | null {
        try {
            return this._storage.getItem(key);
        } catch (error) {
            this.logBreadcrumb(`Failed to get item "${key}" from ${this.storageType} storage`, { key, error });
            return null;
        }
    }

    getItem<T = string> (key: string): T | null {
        const raw = this.getItemRaw(key);
        if (raw === null) return null;
        return this.clearString(raw) as T;
    }

    removeItem (key: string): void {
        try {
            return this._storage.removeItem(key);
        } catch (error) {
            this.logBreadcrumb(`Failed to remove item "${ key }" from ${ this.storageType } storage`, { key, error });
        }
    }

    setItem (key: string, value: string): void {
        try {
            return this._storage.setItem(key, value);
        } catch (error) {
            this.logBreadcrumb(`Failed to set item "${ key }" to ${ this.storageType } storage`, { key, data: value });
        }
    }

    private clearString (str: string): string {
        if (str.startsWith('%')) return this.clearString(decodeURIComponent(str));
        if (
            str.startsWith('"') ||
            str.startsWith("'")
        ) return this.clearString(str.substring(1, str.length - 1));
        if (str.startsWith('\\')) return this.clearString(str.replace(/\\/, ''));
        return str;
    }

    protected logBreadcrumb (message: string, data: Record<string, any>): void {
        this._breadcrumbLogger.addBreadcrumb({
            message,
            data,
            category: 'storage',
            level   : 'warning',
        });
    }
}
